function MenuItemDirective($compile) {
  return {
    template: `
      <li>
        <a>
          <span class="subitem-menu">
            <img ng-src="{{ctrl.ngAuthSettings.config.env.basePath + item.icon}}" alt="">
            <p>{{item.nombre}}</p>
          </span>
        </a>
      </li>`,
    restrict: 'A',
    replace: true,
    controller: controller,
    controllerAs: 'ctrl',
    scope: {
      item: '=menuItem'
    },
    link: function link(scope, element, attrs) {
      if (!scope.item.icono_solo) {
        if (scope.item.header) {
          element.addClass('nav-header');
          element.text(scope.item.header);
        }
        if (scope.item.divider) {
          element.addClass('divider');
          element.empty();
        }
        if (scope.item.hijas){
          let text = element.children('a').text();
          let href = '';
          if (scope.item.url_destino) {
            href = 'href="' + scope.item.url_destino + '" target="_blank"';
          } else {
            href = 'href="./#/' + scope.item.slug + '" target=""';
          }
          element.empty();
          let $a = $('<a ' + href + '>' + text + '</a> <i class="fa fa-chevron-right pull-right"></i>');
          element.append($a);
          
          let $submenu = $('<div menu="item.hijas"></div>');
          element.append($submenu);
        }
        else {
          element.children('a').attr('ui-sref', `home.categorySlugProducts({categorySlug : '${scope.item.slug}'})`);
        }
        
        $compile(element.contents())(scope);
      } else {
        if (scope.item.hijas) {
          let text = element.children('a').text();
          let href = 'href="' + scope.item.url_destino + '"';
          
          element.empty();
          let $a = $('<a ' + href + '>' + text + '</a> <i class="fa fa-chevron-right pull-right"></i>');
          element.append($a);
          
          let $submenu = $('<div menu="item.hijas"></div>');
          element.append($submenu);
        } else {
          element.children('a').attr('href', scope.item.url_destino);
        }
        
        $compile(element.contents())(scope);
      }
    }
  };
}

function controller(ngAuthSettings){
  let vm = this;
  this.ngAuthSettings = ngAuthSettings;
}

controller.$inject = ['ngAuthSettings'];
MenuItemDirective.$inject = ['$compile'];

export default MenuItemDirective;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/home/menu/menu-item/menu-item.directive.js
 **/